export default function MobileStickyCTA() {
  return (
    <div className="mobile-cta" role="region" aria-label="Quick booking">
      <a
        className="btn btn--primary mobile-cta__button"
        href="https://maryvillemassageworks.setmore.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Book Now
      </a>
    </div>
  );
}
